
<template>
  <div class="index-m">
    <div class="index-nav-box">
      <a-anchor wrapperClass="index-nav" :affix="false"  @change="onChange">
        <a-anchor-link href="#index-introduction" title="公司简介" />
        <a-anchor-link href="#index-vision" title="公司愿景" />
        <a-anchor-link href="#index-culture" title="公司文化" />
      </a-anchor>
    </div>

    <div class="index-box-1">
      <div id="index-introduction">
        <div class="index-introduction-title">
          公司简介
        </div>
        <div class="index-introduction-content">
          嘉彩科讯正式注册成立于2019年，是一家集彩票连锁店建设、实体彩票店经营能力提升帮扶、网络平台运营为一体的多元化综合性经营机构。其中采道网络平台采道是一款为彩民和彩票从业者服务的台，是彩民的中奖利器，是彩票从业者的销售助手。
        </div>
      </div>
      <div id="index-vision">
        <div class="index-vision-left">
          <img src="@/assets/images/vision.png" alt="">
        </div>
        <div class="index-vision-right">
          <div class="index-vision-title">
            公司愿景
          </div>
          <div class="index-vision-content">
            用实力和诚心帮助实体彩票店提升，以多元化发展理念带领全国30万彩票店稳步前进。
          </div>
        </div>
      </div>
    </div>

    <div class="index-box-2">
      <div id="index-culture">
        <div class="index-culture-title">
          公司文化
        </div>

        <div class="index-culture-content">
          <div class="index-culture-content-item">
            <img  class="index-culture-content-item-top" src="@/assets/images/culture1.png" alt="">
            <div class="index-culture-content-item-bottom">
              <div>创新</div>
              <div>开拓彩票行业新平台</div>
            </div>
          </div>
          <div class="index-culture-content-item">
            <img  class="index-culture-content-item-top" src="@/assets/images/culture2.png" alt="">
            <div class="index-culture-content-item-bottom">
              <div>拼博</div>
              <div>解决彩民难题及彩票从业者痛点</div>
            </div>
          </div>
          <div class="index-culture-content-item">
            <img  class="index-culture-content-item-top" src="@/assets/images/culture3.png" alt="">
            <div class="index-culture-content-item-bottom">
              <div>共享</div>
              <div>彩民与彩票从业者共享数据资源</div>
            </div>
          </div>
          <div class="index-culture-content-item">
            <img  class="index-culture-content-item-top" src="@/assets/images/culture4.png" alt="">
            <div class="index-culture-content-item-bottom">
              <div>共赢</div>
              <div>彩民及彩票从业者与嘉彩科讯共同发展</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index-m',

  methods: {
    onChange (link) {
      console.log('Anchor:OnChange', link)
    }
  }
}
</script>

<style lang="scss" scoped>
.index-m {
  position: relative;
  .index-nav-box {
    position: sticky;
    top: 0;
    height: 40px;
    background: #FBFBFB;
    padding-left: 25px;

    .index-nav {
      height: 40px;
      background: #FBFBFB;

      ::v-deep .ant-anchor {
        height: 100%;
        @include flex(row, flex-start, center);

        .ant-anchor-ink {
          display: none;
        }

        .ant-anchor-link {
          margin-right: 40px;
          padding: 5px 0;
          font-size: 16px;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: 500;
          color: $text-color;

          .ant-anchor-link-title:hover {
            color: $text-color;
          }
        }

        .ant-anchor-link-active {
          position: relative;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 3px;
            background-color: $base-color;
          }

          .ant-anchor-link-title-active {
            color: $text-color;
          }
        }
      }
    }
  }

  .index-box-1 {
    padding: 0 20px;

    #index-introduction {
      height: 293px;
      @include flex(col, center, center);

      .index-introduction-title {
        font-size: 20px;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: $base-color;
        line-height: 23px;
        margin-bottom: 10px;
      }

      .index-introduction-content {
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 35px;
      }
    }

    #index-vision {
      margin-bottom: 59px;
      @include flex(col);

      .index-vision-left {
        flex: 1;
        img {
          width: 100%;
        }
      }

      .index-vision-right {
        flex: 1;
        background: #F2F2F2;
        @include flex(col, center, center);
        padding: 48px 20px 71px;

        .index-vision-title {
          font-size: 20px;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: bold;
          color: $text-color;
          line-height: 23px;
          margin-bottom: 16px;
        }

        .index-vision-content {
          font-size: 14px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #666666;
          line-height: 28px;
        }
      }
    }
  }

  .index-box-2 {
    background-image: url('~@/assets/images/bg-culture.png');

    #index-culture {
      padding: 20px;

      .index-culture-title {
        width: 100%;
        text-align: center;
        padding: 20px 0 28px;
        font-size: 24px;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: $text-color;
      }

      .index-culture-content {
        .index-culture-content-item {
          @include flex(col);
          margin-bottom: 40px;

          .index-culture-content-item-top {
            width: 100%;
          }

          .index-culture-content-item-bottom {
            height: 128px;
            background: #FFFFFF;
            padding: 30px 0 24px 17px;

            div {
              &:nth-child(1) {
                margin-bottom: 14px;
                font-size: 24px;
                font-family: PingFang SC-Bold, PingFang SC;
                font-weight: bold;
                color: $text-color;
                line-height: 28px;
              }

              &:nth-child(2) {
                font-size: 16px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: $text-color;
                line-height: 27px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
